import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifi1Bar = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M8 1.778c4.516 0 7.529 2.462 7.831 2.693L8.01 14.213h-.002l-.007.01-.007-.01H7.99L.17 4.471C.47 4.24 3.484 1.778 8 1.778"
      />
    </g>
  </svg>
)
export default SvgSignalWifi1Bar
